export const CONFIG = {
  // Google Calendar API credentials.
  // These will prioritize environment variables (starting with REACT_APP_ in Create React App),
  // but you can also paste your credentials directly here if you prefer.
  GOOGLE_CALENDAR_ID: process.env.REACT_APP_GOOGLE_CALENDAR_ID || "f123913879977f96e419f6b1a18360b210175fbbee38a08ce7db237ba82c6a60@group.calendar.google.com",
  GOOGLE_CALENDAR_API_KEY: process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY || "AIzaSyDJJLNtXCm7hRLlKU1dRyQmx87PRhdjiiE",
  TWITCH_CHANNEL: process.env.REACT_APP_TWITCH_CHANNEL || "haloextravalanza",

  // Fallback static events used if Google Calendar is not configured or fails.
  // These are set to 2026 so they represent upcoming events relative to today (May 24, 2026).
  FALLBACK_EVENTS: [
    {
      id: "fallback-1",
      title: "Preseason 03",
      description: "Event 1/3",
      start: "2026-06-21T12:00:00-06:00", // 12pm CST
      end: "2026-06-21T21:00:00-06:00"    // 9pm CST
    },
    {
      id: "fallback-2",
      title: "Preseason 03",
      description: "Event 2/3",
      start: "2026-07-19T12:00:00-06:00", // 12pm CST
      end: "2026-07-19T21:00:00-06:00"    // 9pm CST
    },
    {
      id: "fallback-3",
      title: "Preseason 03",
      description: "Event 3/3",
      start: "2026-08-02T12:00:00-06:00", // 12pm CST
      end: "2026-08-02T21:00:00-06:00"    // 9pm CST
    },
    {
      id: "fallback-4",
      title: "Season 03",
      description: "Draft",
      start: "2026-08-10T19:00:00-06:00", // 7pm CST
      end: "2026-08-10T21:00:00-06:00"    // 9pm CST
    }
  ]
};
